module.exports = __webpack_public_path__ + "static/img/logo3.15626bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo3.png
// module id = Nyh+
// module chunks = 1 2 3 4 5 7 8 9 13 25